<template>
    <div class="panel-header">
        <slot></slot>
    </div>
</template>
<script>

export default {
}

</script>
<style lang="scss" scoped>
.panel-header {
    padding:0.5em 0.5em 0.5em 1em;

    @media(prefers-color-scheme: light) {
        border-bottom: 1px solid color-mix(in lab, currentColor 15%, transparent);
    }

    @media(prefers-color-scheme: dark) {
        border-bottom: 1px solid color-mix(in lab, currentColor 18%, transparent);
    }
}



</style>